import React, { useState } from "react";
import Button from "../../../components/Button";
import CopyQuotationPopup from "./CopyQuotationPopup";

type CopyQuotationProps = {
  quotationId?: string;
  disabled?: boolean;
};

export default function CopyQuotation({
  quotationId,
  disabled = false,
}: CopyQuotationProps) {
  const [openCopyQuotation, setOpenCopyQuotation] = useState(false);

  return (
    <div>
      <Button
        variant="primary"
        label="Make a Copy"
        onClick={() => setOpenCopyQuotation(true)}
        disabled={disabled}
      />
      {openCopyQuotation && (
        <CopyQuotationPopup
          quotationId={quotationId}
          onClose={() => setOpenCopyQuotation(false)}
        />
      )}
    </div>
  );
}
